import { Box, chakra, Flex } from "@chakra-ui/react";

export const PageContainer = chakra(Box, {
  baseStyle: {
    background: "#fff",
    height: "auto",
    minHeight: "100vh",
    overflow: "hidden",
  },
});

export const ListHeaderWrap = chakra(Flex, {
  baseStyle: {
    borderBottom: "1px solid #EBEDF5",
    justifyContent: "space-between",
  },
});

export const TabWrap = chakra(Flex, {
  baseStyle: {
    alignItems: "center",
    // marginBottom: "30px",
    gap: "30px",
  },
});

export const Tab = chakra(Box, {
  baseStyle: {
    fontSize: "24px",
    color: "#7B7C8F",
    paddingBottom: "10px",
    cursor: "pointer",
    "&.active": {
      fontWeight: 600,
      color: "#000",
      borderBottom: "3px solid #3E3D4D",
    },
  },
});

export const CreateLimit = chakra(Flex, {
  baseStyle: {
    background: "#EBEDF5",
    borderRadius: "12px",
    padding: "10px",
    color: "rgba(1, 3, 19, 1)",
    width: "max-content",
    gap: "5px",
    fontSize: "12px",
    height: "38px",
    alignItems: "center",
    img: {
      width: "24px",
      height: "24px",
    },
  },
});

export const ApiKeyWarning = chakra(Flex, {
  baseStyle: {
    alignItems: "center",
    margin: "20px 0px 30px 15px",
    color: "#D04457",
    fontSize: "14px",
    img: {
      marginRight: "5px",
    },
  },
});

export const SearchInputWrap = chakra(Flex, {
  baseStyle: {
    alignItems: "center",
    borderRadius: "30px",
    padding: "10px 15px",
    border: "1px solid #E3E4F1",
    height: "40px",

    input: {
      color: "rgba(53, 51, 74, 1)",
      fontSize: "14px",
      border: "none",
      outline: "none",
      height: "20px",
      ml: "5px",
      _placeholder: {
        color: "#B3B4C8",
      },
    },
  },
});
